export function nextHelpTextFrame(frame, length, total = 2) {
  if (frame.erasing) {
    return frame.count > 0
      ? { ...frame, count: frame.count - 1 }
      : { index: (frame.index + 1) % total, count: 0, erasing: false };
  }
  return frame.count < length
    ? { ...frame, count: frame.count + 1 }
    : { ...frame, erasing: true };
}

export function helpTextDelay(frame, length) {
  if (!frame.erasing && frame.count >= length) return 8000;
  return frame.erasing ? 25 : 55;
}
